import {
  CurrencyCode,
  enumCurrencyCode,
  enumPaymentTerm,
  InvoiceEntityReferenceType,
  InvoiceStatus,
} from '@rematter/frontend-lib-api-client';

import { InvoiceLineItemInput } from '../utils/invoiceLineItems';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const invoiceCreateFromReconciliationAtom = createMutationAtomFactory(
  'trade.invoiceCreate',
  (params: {
    loadId: string;
    accountId: string;
    facilityId: string;
    documentDate: string;
    paymentTerm: (typeof enumPaymentTerm)[keyof typeof enumPaymentTerm];
    amount: number;
    currencyCode?: CurrencyCode;
    notes?: string;
    lineItems?: InvoiceLineItemInput[];
    status?: InvoiceStatus;
    sourceReferences?: Array<{
      entityId: string;
      entityType: InvoiceEntityReferenceType;
    }>;
  }) => ({
    financeInvoiceCreate: {
      __args: {
        input: {
          type: 'OutboundInvoice' as const,
          documentDate: params.documentDate,
          amount: {
            amount: params.amount,
            currencyCode: params.currencyCode ?? enumCurrencyCode.USD,
          },
          paymentTerm: params.paymentTerm,
          notes: params.notes,
          accountID: params.accountId,
          facilityID: params.facilityId,
          lineItems: params.lineItems,
          status: params.status,
          sourceReferences: params.sourceReferences,
        },
      },
      id: true,
      documentNumber: true,
      amount: {
        amount: true,
        currencyCode: true,
      },
      status: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
);
